import type { MediaKind } from "@edu/shared";

/**
 * Значки списка материалов.
 *
 * Свои SVG прямо в коде, а не пакет иконок и тем более не шрифт с чужого
 * домена: при шатдауне с белым списком страница обязана отрисоваться целиком
 * (раздел 4 CLAUDE.md). Четыре фигуры дешевле любой зависимости.
 *
 * `currentColor` и никаких размеров внутри: цвет и размер задаёт CSS, поэтому
 * значок одинаково читается в списке и в приглушённой карточке корзины.
 */

function Svg(props: { children: React.ReactNode; label: string }) {
  return (
    <svg
      className="mi"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={props.label}
    >
      {props.children}
    </svg>
  );
}

export function FolderIcon() {
  return (
    <Svg label="папка">
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </Svg>
  );
}

export function KindIcon({ kind }: { kind: MediaKind }) {
  switch (kind) {
    case "video":
      return (
        <Svg label="видео">
          <rect x="3" y="6" width="12" height="12" rx="2" />
          <path d="M15 10.5 21 7v10l-6-3.5z" />
        </Svg>
      );
    case "audio":
      return (
        <Svg label="аудио">
          <path d="M9 18V6l10-2v12" />
          <circle cx="6.5" cy="18" r="2.5" />
          <circle cx="16.5" cy="16" r="2.5" />
        </Svg>
      );
    case "image":
      return (
        <Svg label="картинка">
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <circle cx="8.5" cy="9.5" r="1.5" />
          <path d="m4 17 5-5 4 4 2-2 5 5" />
        </Svg>
      );
    case "doc":
      return (
        <Svg label="документ">
          <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
          <path d="M14 3v5h5" />
        </Svg>
      );
  }
}

/**
 * «Играть» поверх кадра видео на плитке формы выдачи
 * (docs/homework-media-form-player-plan.md, Р7). Залитый треугольник, а не
 * контур: в круге размером со значок контур тонкой линией не читается.
 * Украшение: что делает нажатие, говорит подпись кнопки плитки.
 */
export function PlayIcon() {
  return (
    <svg className="mi" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M8 5.5v13l11-6.5z" />
    </svg>
  );
}
